import React, { useEffect, useState } from 'react';
import { Divider, Stack, Typography, Box } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';
import { Scanner } from '@yudiel/react-qr-scanner';

export default function BarCodeScanner({open, onClose, title = 'Barcode Scanner' }) {

    const handleClose = () => {
        onClose();
        setChipNumber("No result");
    };

    const handleScan = (result) => {
      console.log(result);
      setChipNumber(result[0].rawValue);
    };

    const [chipNumber, setChipNumber] = useState("No result");

    return (
        <React.Fragment>

        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            <DialogTitle>
            {title}
            </DialogTitle>
            <DialogContent
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",     // horizontal centering
                justifyContent: "center", // vertical centering
              }}
            >
              {/* {open && (
                <BarcodeScanner
                  onSuccess={(text) => setChipNumber(text)}
                  constraints={{ facingMode: "environment" }}
                  style={{ width: "100%" }}
                />
              )} */}
              <Scanner
                onScan={handleScan}
                onError={(error) => console.log(error?.message)}
              />
              <p>Microchip Number: {chipNumber}</p>
              <Typography textAlign={'center'} variant='body1'>Barcode Scanner</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
        </React.Fragment>
    );
}